

/**
 * @file
 * Behaviors for the Carousel.
 */

 !((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Carousel behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.carousel = {
    attach: function() {
      $('.alert-close').click(function(){
        $('.alert-close').parent().hide();
      });      
    }
  };
})(Drupal, jQuery);
